"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Vue, Component, PropSync } from "vue-property-decorator";
import ItemShop from "@/components/virtual-shop/elements/item-shop/ItemShop.vue";
import _ from "lodash";
let ItemElementShops = class extends Vue {
  get shopGroups() {
    return _.chunk(this._shops, 5);
  }
  bindShop() {
    this.$emit("bindshop");
  }
};
__decorateClass([
  PropSync("shops")
], ItemElementShops.prototype, "_shops", 2);
__decorateClass([
  PropSync("showAdd", {
    default: function() {
      return true;
    }
  })
], ItemElementShops.prototype, "_showAdd", 2);
ItemElementShops = __decorateClass([
  Component({
    components: {
      ItemShop
    }
  })
], ItemElementShops);
export {
  ItemElementShops as default
};
